export const HOOKS_ICON = "sparkles";
export const HOOKS_ICON_GRAY = "sparkles-gray";
